<template>
    <div v-if="products !== null && Array.isArray(products)">
        <button type="button" class="button" @click="$router.push('/admin/product/new')">Create New Product</button>
        <b-table :data="products" default-sort="name">
            <template slot-scope="props">
                <b-table-column label="Controls">
                    <i class="fa fa-edit fa-2x" @click="$router.push({name: 'AdminProductEdit', params: {id: props.row.id}})"></i>
                </b-table-column>
                <b-table-column label="Name" field="name" sortable>
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column label="Price" field="price" sortable numeric>
                    ${{ (props.row.price / 100).toFixed(2) }}
                </b-table-column>
                <b-table-column label="In Stock" field="in_stock" sortable>
                    <i class="fa fa-check" v-if="props.row.in_stock"></i>
                    <i class="fa fa-times" v-else></i>
                </b-table-column>
                <b-table-column label="Categories">
                    <div v-for="category in props.row.categories" :key="category.id">
                        {{category.name}}
                    </div>

                </b-table-column>
            </template>
        </b-table>
    </div>
    <loader v-else></loader>
</template>

<script>
import Loader from '../Loader';
import BTable from 'buefy/src/components/table/Table';
import BTableColumn from 'buefy/src/components/table/TableColumn';

export default {
  components: {
    BTableColumn,
    BTable,
    Loader,
  },
  name: 'admin-products',

  created() {
    this.$store.dispatch('adminProduct/loadAll');
  },

  computed: {
    products() {
      return this.$store.state.adminProduct.products;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminProducts.vue